import { render, staticRenderFns } from "./TimelineItemForm.vue?vue&type=template&id=3b3eb76e&scoped=true"
import script from "./TimelineItemForm.vue?vue&type=script&lang=ts"
export * from "./TimelineItemForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3eb76e",
  null
  
)

export default component.exports